import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DTypeFormFileField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { DTypeFormFieldComponent } from '../../dtype-field.model';

@Component({
    selector: 'file-field-component',
    templateUrl: './file-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class DtypeFileFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormFileField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    constructor() { }

    ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
    }

}
